import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="ChatAdminPane">
            <label>
                <input type="checkbox" :checked="hideremoved" @input="$emit('update:hideremoved', $event.target.checked)" />

                Ukryj usunięte
            </label>
        </div>
    `,

    emits: [
        'update:hideremoved'
    ],

    props: {
        hideremoved: { type: Boolean },
    },
});
